import { useCallback, useRef, useState } from 'react';
import { generateAndDownloadPdf } from '@/utils/pdf/exportPdf';

export interface UseReportExportResult {
    exportRef: React.RefObject<HTMLDivElement | null>;
    downloading: boolean;
    exportPdf: (fileName?: string, onComplete?: () => void) => Promise<void>;
}

const useReportExport = (): UseReportExportResult => {
    const exportRef = useRef<HTMLDivElement | null>(null);
    const [downloading, setDownloading] = useState(false);

    const exportPdf = useCallback(
        async (fileName = 'IndividualReport.pdf', onComplete?: () => void) => {
            if (downloading || !exportRef.current) {
                return;
            }

            setDownloading(true);
            try {
                await generateAndDownloadPdf(exportRef.current, fileName, { padding: '12mm' }, 'Export');
                onComplete?.();
            } catch (error) {
                console.error('PDF export failed:', error);
                throw error;
            } finally {
                setDownloading(false);
            }
        },
        [downloading, exportRef]
    );

    return {
        exportRef,
        downloading,
        exportPdf,
    };
};

export default useReportExport;
